module.exports = __webpack_public_path__ + "static/media/menu-picker.3a4b6b19.svg";